import { FAKE_DATA, USE_FAKE_DATA } from "services/fakeData";
import { getUserId } from "services/storage/general";
import { getToken } from "../../auth/tokenAuth";
import doRequest from "../../helpers";
import helpers from "./helpers";

export const requestGetResources = async ({
	resourceTypeId: idServicioPrestamo,
	libraryId: idBiblioteca,
	campusId: idCampus,
	date: fecha,
	page: pagina,
}) => {
	if (USE_FAKE_DATA) return FAKE_DATA.RESOURCES[idServicioPrestamo];
	const [result, err] = await doRequest(
		"/Recurso/ObtenerListaServicios",
		"POST",
		{
			idServicioPrestamo,
			idCampus,
			idBiblioteca,
			fecha,
			pagina,
			codigoUsuario: getUserId(),
		}, getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data.data?.mensaje) {
		return {
			error: data.data.mensaje,
		};
	}
	const { listServicios, cantidad } = data.data;
	return {
		resources: listServicios?.map(helpers.parseToResource),
		total: cantidad,
		error: null,
	};
};
export const requestGetNameForResource = async ({
	resourceTypeId,
	libraryId,
}) => {
	if (USE_FAKE_DATA) return FAKE_DATA.NEW_NAME_FOR_RESOURCE;
	const [result, err] = await doRequest(
		`/ObtenerNuevoNombreServGeneral/${resourceTypeId}/${libraryId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.nombreNuevo;
};
export const requestCreateElectronicService = async ({
	resourceTypeId: idServicioPrestamo,
	campusId: idCampus,
	libraryId: idBiblioteca,
	name: nombre,
	model: modelo,
	brandId: idMarca,
	serial: serie,
	barcode: codigoBarras,
	details: detalles,
}) => {
	const body = {
		idServicioPrestamo,
		nombre,
		idCampus,
		idBiblioteca,
		idMarca,
		codigoBarras,
		modelo: modelo || null,
		serie: serie || null,
		detalles: detalles || null,
		codigoUsuario: getUserId(),
	};
	const [result, err] = await doRequest(
		"/Recurso/CrearServicioElectronico",
		"POST",
		body,
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};
export const requestUpdateElectronicService = async ({
	id: idServicioGeneral,
	brandId: idMarca,
	model: modelo,
	serial: serie,
	barcode: codigoBarras,
	details: detalles,
}) => {
	const body = {
		idServicioGeneral,
		idMarca,
		codigoBarras,
		modelo: modelo || null,
		serie: serie || null,
		detalles: detalles || null,
		codigoUsuario: getUserId(),
	};
	const [result, err] = await doRequest(
		"/Recurso/EditarServicioElectronico",
		"POST",
		body,
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![0, 1].includes(data?.state)) return false;
	return data.data.exito;
};
export const requestCreateGroupRoomResource = async ({
	resourceTypeId: idServicioPrestamo,
	campusId: idCampus,
	libraryId: idBiblioteca,
	name: nombre,
	capacity,
	screenId: idPantalla,
	environment,
	address,
	details,
}) => {
	const [result, err] = await doRequest(
		"/Recurso/CrearSalasGrupales",
		"POST",
		{
			idServicioPrestamo,
			idCampus,
			idBiblioteca,
			nombre,
			capacidad: Number(capacity),
			idPantalla,
			ambiente: environment ? environment : null,
			direccion: address ? address : null,
			detalles: details ? details : null,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			message: null,
		};
	const { data } = result;
	if (data?.state !== 1)
		return {
			success: false,
			message: null,
		};
	return {
		success: data.data.exito,
		message: data.data.mensaje,
	};
};
export const requestUpdateGroupRoomResource = async ({
	id: idServicioGeneral,
	capacity,
	screenId: idPantalla,
	environment,
	address,
	details,
}) => {
	const [result, err] = await doRequest(
		"/Recurso/EditarSalasGrupales",
		"POST",
		{
			idServicioGeneral,
			capacidad: Number(capacity),
			idPantalla,
			ambiente: environment ? environment : null,
			direccion: address ? address : null,
			detalles: details ? details : null,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			success: false,
			message: null,
		};
	const { data } = result;
	if (![0, 1].includes(data?.state))
		return {
			success: false,
			message: null,
		};
	return {
		success: data.data.exito,
		message: data.data.mensaje,
	};
};
export const requestGetChangeHistoryResource = async resourceId => {
	const [result, err] = await doRequest(
		`/Recurso/Historial/${resourceId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (!data.data) return null;
	return data.data.map(
		({ fecha, hora, detalles, electronico, sala, cambios }) => ({
			date: fecha,
			time: hora,
			details: detalles,
			...helpers.parseToResourceHistory.electronicResource(electronico),
			...helpers.parseToResourceHistory.groupRoomResource(sala),
			changes: helpers.parseToResourceHistory.changes(cambios),
		})
	);
};
export const requestToggleActivationResource = async ({
	resourceId: idServicio,
	active: activo,
}) => {
	const [result, err] = await doRequest(
		"/Recurso/EditarActivo", "POST",
		{
			idServicio,
			activo,
			codigoUsuario: getUserId()
		},
		 getToken());
    if (err)
        return {
            success: false,
            message: null
        };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return {
            success: false,
            message: null
        };
    const { exito, mensaje } = data.data;
    // ERRORES POSIBLES: RESERVAS_FUTURAS
    return {
        message: mensaje,
        success: exito
    };
};
export const requestDeleteResource = async ({
	resourceId: idServicio,
	reasonForDeletion: motivoEliminacion,
}) => {
    const [result, err] = await doRequest(
		"/Recurso/EliminarServicio", "POST",
        {
			idServicio, motivoEliminacion,
			codigoUsuario: getUserId(),
        }, getToken());
    if (err)
        return {
            success: false,
            message: null
        };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return {
            success: false,
            message: null
        };
    const { exito, mensaje } = data.data;
    // ERRORES POSIBLES: RESERVAS_FUTURAS
    return {
        message: mensaje, 
        success: exito
    };
};
export const requestGetAvailableResourceToReassignment = async ({
	date: fecha,
	timeStart: horaInicio,
	timeEnd: horaFin,
	resourceId: idRecurso,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/ObtenerRecursoDisponibleReasignacion",
		"POST",
		{
			fecha,
			horaInicio,
			horaFin,
			idRecurso,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const { recurso } = data.data;
	return (
		recurso && {
			id: recurso.idRecurso,
			name: recurso.nombre,
		}
	);
};
export const requestReassignReservationOfResource = async ({
	resourceId,
	reservationIdToInactive,
	reservationType,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/ReasignarReserva",
		"POST",
		{
			idRecurso: resourceId,
			idReservaInactivar: reservationIdToInactive,
			tipoReserva: reservationType,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data?.exito;
};
export const requestCancelReservationOfResource = async ({
	reservationId,
	reservationType,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/CancelarReserva",
		"POST",
		{
			idReserva: reservationId,
			tipoReserva: reservationType,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data?.exito;
};

export const requestRegisterAdminReservation = async ({
	resourceId: idRecurso,
	name: nombre,
	details: detalles,
	date: fecha,
	timeStart: horaInicio,
	timeEnd: horaFin,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/ReservaManual",
		"POST",
		{
			idRecurso, nombre, detalles,
			fecha, horaInicio, horaFin,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};

export const requestSaveReservationState = async ({
	reservationId,
	finalized,
	reservationType,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/GuardarReserva",
		"POST",
		{
			idReserva: reservationId,
			finalizado: finalized,
			tipoReserva: reservationType,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};

export const requestPenalizeStudent = async ({
	reservationDetailIds,
	reasonForPenalizeId,
	blockId,
	penalizeDays,
	details,
	resourceTypeId,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/SancionarAlumno",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			idMotivo: reasonForPenalizeId,
			idBloqueo: blockId,
			dias: parseInt(penalizeDays),
			detalles: details,
			idServicioPrestamo: resourceTypeId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};

export const requestUpdatePenaltyStudent = async ({
	studentPenalizedIds,
	blockId,
	penalizeDays,
	details,
	resourceTypeId,
}) => {
	const [result, err] = await doRequest(
		"/ReservaRecurso/EditarSancionAlumno",
		"POST",
		{
			idsAlumnosSancionados: studentPenalizedIds,
			idBloqueo: !penalizeDays ? blockId : 0,
			dias: !blockId ? parseInt(penalizeDays) : 0,
			detalles: details,
			idServicioPrestamo: resourceTypeId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};

export async function requestAddStudentsToGroupRoomReservation({
	students, reservationId
}) {
	const [result, err] = await doRequest(
		"/ReservaRecurso/AgregarAlumno",
		"POST",
		{
			idReserva: reservationId,
			estudiantes: students.map(({ id, name }) => ({
				codAlumno: id,
				nombreAlumno: name,
			})),
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err)
		return {
			newStudent: null,
			message: null,
		};
	const { data } = result;
	if (![1, 0].includes(data?.state))
		return {
			newStudent: null,
			message: null,
		};
	const { exito, mensaje } = data.data;
	return {
		success: exito,
		message: mensaje || null,
	};
}

export async function requestTakeStudentAttendanceInGroupReservation({
	reservationDetailIds,
}) {
	const [result, err] = await doRequest(
		"/ReservaRecurso/AsistenciaAlumno",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.exito;
}

export async function requestDeleteStudentsFromGroupRoomReservation({
	reservationDetailIds
}) {
	const [result, err] = await doRequest(
		"/ReservaRecurso/EliminarAlumno",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.exito;
}

export async function requestValidatePenalizeInGroupReservation({
	reservationDetailIds,
	resourceTypeId,
}) {
	const [result, err] = await doRequest(
		"/ReservaRecurso/ValidarCrearSancion",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			idServicioPrestamo: resourceTypeId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.alumnosConSancion.map(({ idAlumno, nombres }) => ({
		id: idAlumno,
		name: nombres,
	}));
}

export async function requestValidateUpdatePenaltyInGroupReservation({
	studentPenalizedIds,
	resourceTypeId,
}) {
	const [result, err] = await doRequest(
		"/ReservaRecurso/ValidarEditarSancion",
		"POST",
		{
			idsAlumnosSancionados: studentPenalizedIds,
			idServicioPrestamo: resourceTypeId,
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	// "SANCIONES_DIFERENTES"
	return data.data.mensaje;
}

export async function requestValidateDeletionStudentInGroupRoomReservation({
	reservationDetailIds,
}) {
	const [result, err] = await doRequest(
		"/ReservaRecurso/ValidarEliminacion",
		"POST",
		{
			idsDetalleReserva: reservationDetailIds,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![1, 0].includes(data?.state)) return false;
	return data.data.exito;
}